var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666626 17.5C0.666626 7.83502 8.50164 0 18.1666 0C27.8316 0 35.6666 7.83502 35.6666 17.5C35.6666 27.165 27.8316 35 18.1666 35C8.50164 35 0.666626 27.165 0.666626 17.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2949 10.8082C13.2691 9.63988 12.4336 8.75 11.0769 8.75C9.72022 8.75 8.83325 9.63988 8.83325 10.8082C8.83325 11.9524 9.694 12.8679 11.0254 12.8679H11.0508C12.4336 12.8679 13.2949 11.9524 13.2949 10.8082Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0337 14.4943H9.06777V26.4102H13.0337V14.4943Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7699 14.2145C25.3797 14.2145 27.3362 15.9179 27.3362 19.5779L27.336 26.4101H23.3703V20.0351C23.3703 18.4339 22.7964 17.3412 21.3607 17.3412C20.2651 17.3412 19.6124 18.0778 19.3258 18.7893C19.221 19.0443 19.1952 19.3995 19.1952 19.7556V26.4104H15.2289C15.2289 26.4104 15.2811 15.6127 15.2289 14.4946H19.1952V16.1824C19.7216 15.371 20.6643 14.2145 22.7699 14.2145Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedinIcon.2344507c6bd0a96febaaa0bd68001b81.svg";
export { ForwardRef as ReactComponent };